import './styles.scoped.css';
export default {
  "header-cell": "awsui_header-cell_1spae_16xmx_93",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_16xmx_103",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_16xmx_106",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_16xmx_106",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_16xmx_109",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_16xmx_115",
  "header-cell-resizable": "awsui_header-cell-resizable_1spae_16xmx_127",
  "sorting-icon": "awsui_sorting-icon_1spae_16xmx_131",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_16xmx_138",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_16xmx_138",
  "header-cell-content": "awsui_header-cell-content_1spae_16xmx_138",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_16xmx_171",
  "header-cell-text": "awsui_header-cell-text_1spae_16xmx_200",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_16xmx_200",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_16xmx_206",
  "header-cell-descending": "awsui_header-cell-descending_1spae_16xmx_207"
};